import { mergeClasses } from '@blank/utilities'
import { IconCheck } from 'modules/common/components/_icons/icons'
import { SignupStepStatus } from './Step'

interface Props {
  stepNumber: number
  stepStatus?: SignupStepStatus
}
export const StepIcon = ({ stepNumber, stepStatus }: Props) => {
  return (
    <div
      className={mergeClasses(
        'flex h-10 w-10 items-center justify-center rounded-full bg-white text-lg font-bold text-primary',
        { 'text-primary-600': stepStatus === 'editing' }
      )}
    >
      {stepStatus === 'done' ? <IconCheck /> : <>{stepNumber}</>}
    </div>
  )
}
